import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
var Skeleton = function (_a) {
    var children = _a.children, className = _a.className, show = _a.show;
    return (_jsx("div", { className: clsx('transition-opacity duration-300', className, show && 'opacity-100', !show && 'opacity-0 pointer-events-none'), children: children }));
};
export { Skeleton as default };
